import { Navigate, Outlet, RouteObject } from "react-router";
import { SummariesIndexRoute } from "@/routes/processes/[processId]/htz/summaries/_components/summaries-index-route";
import { SummaryRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/summary-route";
import { DataRoute as SummaryDataRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/data/data-route";
import { ItemsRoute as SummaryItemsRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/items-route";
import { AddressesAndContactsRoute as SummaryAddressesAndContactsRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/addresses-and-contacts/addresses-and-contacts-route";
import { ReportRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/report-route";
import { htzSummaryItemReportRoutes } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/report-routes";

// An Anlagenbericht is only reachable through the item of the
// Inspektionsbericht summarizing it. Its page is a sibling of the
// summary page (not a child), so it does not render inside the
// summary's document page.
export const htzSummariesRoutes: RouteObject[] = [
  {
    index: true,
    element: <SummariesIndexRoute />,
  },
  {
    path: ":summaryId",
    element: <Outlet />,
    children: [
      {
        element: <SummaryRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="data" replace />,
          },
          {
            path: "data",
            element: <SummaryDataRoute />,
          },
          {
            path: "items",
            element: <SummaryItemsRoute />,
          },
          {
            path: "addresses-and-contacts",
            element: <SummaryAddressesAndContactsRoute />,
          },
        ],
      },
      {
        path: "items/:itemId/report",
        element: <ReportRoute />,
        children: htzSummaryItemReportRoutes,
      },
    ],
  },
];
